import React, {useEffect, useRef, useState} from "react"
import {UserAgreements} from "./UserAgreements";
import {BasicInfo} from "./BasicInfo";
import {RegistrationInfo} from "./RegistrationInfo";
import {FieldsOfInterest} from "./FieldsOfInterest";
import "./UserRegistration.css"
import BackgroundImage from "../../assets/img/recruitment-homepage-images/background.png";
import Logo from "../../assets/img/logo/logo.png"
import LogIn from "../../assets/img/logIn/logIn.jpg"
import LogInWithLogo from "../../assets/img/logIn/Login-fotografija.png"
import {updateResource} from "../service/http-service";

export const UserRegistration = () => {
    const [page, setPage] = useState(0)
    // const FormTitles = ["Основни Информации", "Полиња на интерес", "Регистрација"]
    const [userInfo, setUserInfo] = useState({
        firstName : "",
        lastName: "",
        birthDate: "",
        email: "",
        phone: "",
        gender:null,
        educationType: {},
        educationSchool: {},
        educationTitle: {},
        educationInstitution: {},
        enrollmentDate: null,
        completionDate:null,
        customEducationInstitution: "",
        customEducationTitle:"",
        customEducationSchool:"",
        userName:"",
        password:"",
        fieldOfInterests:[],
        agreementToBeKeptInDatabase: false,
        agreementToApplyOnOneAd: false,
        agreementForReceivingNotifications:false
    })

    const RegisterFormRef = useRef(null);

    useEffect(() => {
        goToRegisterRef();
    },[])


    const goToRegisterRef = () => {
        window.scrollTo({
            top: RegisterFormRef.current.offsetTop - 50,
            behavior: "auto",
        });
    }

    const PageDisplay = () => {
        if(page === 0) {
            return <UserAgreements userInfo={userInfo} setUserInfo={setUserInfo} page={page} setPage={setPage} />
        }else if(page === 1) {
            return <BasicInfo userInfo={userInfo} setUserInfo={setUserInfo} page={page} setPage={setPage}/>
        } else if (page === 2) {
            return <FieldsOfInterest userInfo={userInfo} setUserInfo={setUserInfo} page={page} setPage={setPage}/>
        }  else if (page === 3) {
            return <RegistrationInfo userInfo={userInfo} setUserInfo={setUserInfo} page={page} setPage={setPage}/>
        }
    }
    return (
        <div className="container-fluid m-0 p-0" id="registrationDiv">
            <div className="row m-0 p-0 backgroundImage">
                <img src={BackgroundImage} className="backgroundImage m-0 p-0" alt="background-image" onLoad={() => goToRegisterRef()}/>
                <div className="col-md-10 offset-md-1 col-12">
                    <div className="row m-0 p-0">
                        <div className="col-md-4 col-7 main-title">
                            АПЛИКАЦИЈА ЗА КАРИЕРА
                        </div>
                    </div>
                </div>
            </div>
            <div className="row mx-3 p-0">
                <div className="col-md-10 offset-md-1 col-12 p-0 logIn-container">
                    <img src={Logo} className="logIn-logo"/>
                    <img src={LogIn} className="logIn-img" onLoad={() => goToRegisterRef()}/>
                    <div className="logIn-content"  style={{backgroundImage: `url(${LogInWithLogo})`}} ref={RegisterFormRef}>
                            <div className="form-container">
                                <div className="form-title mb-3">
                                    <h2>КРЕИРАЈ НОВ ПРОФИЛ</h2>
                                </div>
                                <div className="form-body">
                                   {/*<h3 className="stepper-title"> {FormTitles[page]}</h3>*/}
                                         {PageDisplay()}
                                </div>

                            </div>
                        <div className="white-space" ></div>
                    </div>
                </div>
            </div>
        </div>


    )
}